import { render, staticRenderFns } from "./ReActionLabel.vue?vue&type=template&id=0acd58e6"
import script from "./ReActionLabel.vue?vue&type=script&lang=js"
export * from "./ReActionLabel.vue?vue&type=script&lang=js"
import style0 from "./ReActionLabel.vue?vue&type=style&index=0&id=0acd58e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports